import Vue from 'vue'
import { AuthState, User } from './types'

const getDefaultState = () => {
    const state: AuthState = {
        user: undefined,
        entityId: ""
    }
    return state;
}

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_USER(state: AuthState, user: User) {
            state.user = user
        },
        SET_ENTITY(state: AuthState, entityId: string) {
            state.entityId = entityId
        },
        LOG_OUT(state: AuthState) {
            state.user = undefined;
        },
        RESET_STATE(state: AuthState) {
            Object.assign(state, getDefaultState())
        }
    },
    actions: {
        async login({ commit }, { username, password, otpCode }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('username', username);
            params.append('password', password);
            if (otpCode)
                params.append('otpCode', otpCode);
            // SET AUTH OPTIONS
            const options = [
                "WMPC_USER_SETTINGS"
            ];
            params.append('options', JSON.stringify(options))
            //
            try {

                const key = `deviceToken:${username.toLowerCase()}`;
                const deviceToken = localStorage.getItem(key);
                if (deviceToken) {
                    Vue.axios.defaults.headers.common["X-Trusted-Device"] = deviceToken;
                }

                const response = await Vue.axios.post('auth', params);

                const _user = response.data as Partial<User>;
                if (_user.message === "CODE_SENT" || _user.message === "CODE_INVALID") {
                    return _user;
                }

                const user: User = response.data;



                Vue.axios.defaults.headers.common['Authorization'] = "Bearer " + user.token;
                sessionStorage.setItem('token', user.token);

                if (user.deviceToken) {
                    Vue.axios.defaults.headers.common["X-Trusted-Device"] = user.deviceToken;
                    //localStorage.setItem('deviceToken', user.deviceToken);
                    const key = `deviceToken:${user.userName.toLowerCase()}`;
                    localStorage.setItem(key, user.deviceToken);
                }

                commit('SET_USER', user);
                if (user.entities.length) {
                    var defaultEntity = user.entities.filter(e => e["isDefault"] === true);

                    const { id, messagingOutput } = defaultEntity.length ? defaultEntity[0] : user.entities[0];

                    commit('SET_ENTITY', id);
                    commit("gaps/RESET_FILTER", id, { root: true });
                    commit("cases/RESET_FILTER", id, { root: true });
                    commit("cases/RESET_CASE_TASKS_FILTER", id, { root: true });
                    commit("schedule/RESET_FILTER", id, { root: true });
                    commit("schedule/SET_MESSAGING_OUTPUT", messagingOutput, { root: true });
                    commit("calls/RESET_FILTER", id, { root: true });
                }
                return user;
            } catch (err) {
                sessionStorage.removeItem('token');
                throw err;
            }
        },
        async logout({ commit }) {
            delete Vue.axios.defaults.headers.common['Authorization'];
            sessionStorage.removeItem('token');
            commit('LOG_OUT');
            commit('RESET_STATE');
            commit('gaps/RESET_STATE', null, { root: true });
            commit('cases/RESET_STATE', null, { root: true });
            commit('patients/RESET_STATE', null, { root: true });
            commit('schedule/RESET_STATE', null, { root: true });
            commit('providers/RESET_STATE', null, { root: true });
            commit('calls/RESET_STATE', null, { root: true });
        },
        async requestPasswordReset({ commit }, { email, phone }) {
            // SET FORM DATA
            const params = new FormData();
            if (email) params.append('email', email);
            if (phone) params.append('phone', phone.replace(/\D/g, ''));
            // REQUEST RESET ASYNC
            const { data } = await Vue.axios.post("user/password/reset/request", params);
            //
            return data;
        },
        async requestPasswordChange({ commit }) {

            // REQUEST RESET ASYNC
            const { data } = await Vue.axios.post("user/password/change/request");
            //
            return data;
        },
        async verifyPasswordReset({ commit }, publicId: string) {
            // SET FORM DATA
            const params = new FormData();
            params.append('publicId', publicId);
            // VERIFY RESET ASYNC
            const { data } = await Vue.axios.post("user/password/reset/verify", params);
            //
            return data;
        },
        async resetPassword({ commit }, { publicId, password }) {
            // SET FORM DATA
            const params = new FormData();
            params.append('publicId', publicId);
            params.append('password', password);
            // RESET PASSWORD ASYNC
            const { data } = await Vue.axios.post("user/password/reset", params);
            //
            return data;
        },
        async deviceAuthorize({ commit }, key: string) {
            // SET FORM DATA
            const params = new FormData();
            params.append("key", key);
            // GET APPT ASYNC
            const { data } = await Vue.axios.post("auth/device/authorize", params);
            //
            return data;
        },
    },
    getters: {
        loggedIn: (state: AuthState) => !!state.user,
    }
}
